import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Button } from '@pijma/crypto'

import { RootState } from '@stores'
import { TPayFormState } from '@stores/types/*'
import styled from 'styled-components'

import { appClose } from '../../../../helpers/route-utils'
import { H4 } from '../../../common/header/Headings'
import { IconNegative } from '../../../common/icons/IconNegative'
import { FlexBoxCenteredLayout } from '../../../common/layout/flex-box'
import { BodyText600, CaptionText500 } from '../../../common/text/BodyText'

interface StateProps {
  payForm: TPayFormState
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  white-space: pre-wrap;
`

const TitleWrapper = styled.div`
  margin-top: 16px;
  white-space: pre-wrap;
`

const TipWrapper = styled.div`
  margin-top: 8px;
  margin-left: 42px;
  margin-right: 42px;
  white-space: pre-wrap;
`

const BackContainer = styled.div`
  white-space: pre-wrap;
  margin-top: 24px;
  color: #217aac;

  span {
    cursor: pointer;
    :hover {
      color: rgb(49, 49, 49);
    }
  }
`

const ButtonWrapper = styled.div`
  margin: 32px 0 0 0;
`

const ShopInsufficientFundsPage = (props: StateProps) => {
  const intl = useIntl()
  const redirectTo = useNavigate()

  return (
    <FlexBoxCenteredLayout>
      <Container>
        <IconNegative />
        <TitleWrapper>
          <H4>
            {intl.formatMessage({ id: 'shopInsufficientFundsPage.title' })}
          </H4>
        </TitleWrapper>

        <TipWrapper>
          <CaptionText500>
            {intl.formatMessage({ id: 'shopInsufficientFundsPage.tip' })}
          </CaptionText500>
        </TipWrapper>

        <ButtonWrapper>
          <Button
            width={'100%'}
            size={'m'}
            type={'primary'}
            onPress={() =>
              redirectTo(`../${props.payForm.application?.shopCode}`)
            }
          >
            {intl.formatMessage({
              id: 'shopInsufficientFundsPage.changeAmount',
            })}
          </Button>
        </ButtonWrapper>
        <BackContainer onClick={appClose}>
          <BodyText600>
            {props.payForm.application?.product
              ? intl.formatMessage(
                  { id: 'shopInsufficientFundsPage.back' },
                  { product: props.payForm.application.product },
                )
              : null}
          </BodyText600>
        </BackContainer>
      </Container>
    </FlexBoxCenteredLayout>
  )
}

const mapStateToProps = (state: RootState): StateProps => ({
  payForm: state.payForm,
})

export default connect(mapStateToProps)(ShopInsufficientFundsPage)
